import { render, staticRenderFns } from "./PopupBookingStepsComponent.vue?vue&type=template&id=2be6821a"
import script from "./PopupBookingStepsComponent.vue?vue&type=script&lang=js"
export * from "./PopupBookingStepsComponent.vue?vue&type=script&lang=js"
import style0 from "./PopupBookingStepsComponent.vue?vue&type=style&index=0&id=2be6821a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports